import { Route, Routes } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';

import { DrawerProvider } from 'components/Drawer';
import { ModalProvider } from 'components/Modal';
import { CompanyDetails, IndividualDetails, KnowYourCustomer, Layout } from 'pages';
import { Billing } from 'pages/Billing/Billing';
import { Forbidden } from 'pages/Forbidden';
import { AuditLog } from 'pages/KnowYourCustomer/AuditLog/AuditLog';
import { routes } from 'routes';

export const Main = withAuthenticationRequired(() => {
  return (
    <ModalProvider>
      <DrawerProvider>
        <Layout>
          <Routes>
            {/* other routes */}
            <Route path={routes.home.knowYourCustomer} element={<KnowYourCustomer />} />
            <Route path={routes.home.billing} element={<Billing />} />
            <Route path={routes.home.companyDetails} element={<CompanyDetails />} />
            <Route path={routes.home.individualDetails} element={<IndividualDetails />} />
            <Route path={routes.home.auditLog} element={<AuditLog />} />
            <Route path="/" element={<KnowYourCustomer />} />
            <Route path="*" element={<KnowYourCustomer />} />
            <Route path="/forbidden" element={<Forbidden />} />
          </Routes>
        </Layout>
      </DrawerProvider>
    </ModalProvider>
  );
});
